<template>
    <div>
        <el-dialog :title="title" width="70%" center :close-on-click-modal="false" :visible.sync="showDialog"
            @close="setDialogClosed" append-to-body>
            <el-container class="container">
                <div>
                    <el-descriptions :column="2">
                        <el-descriptions-item label="姓名">{{ detail.name }}</el-descriptions-item>
                        <el-descriptions-item label="编号">{{ detail.physicalExamNum }}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions :column="2">
                        <el-descriptions-item label="体检日期">{{ detail.physicalExamTime }}</el-descriptions-item>
                        <el-descriptions-item label="责任医生">{{ detail.responseDoctorName }}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions :column="1" size="medium" border>
                        <el-descriptions-item label="内容"
                            :contentStyle="{ 'background': '#FAFAFA' }">检查项目</el-descriptions-item>
                        <el-descriptions-item label="症状">
                            <el-checkbox-group style="display: inline" v-model="detail.symptomName">
                                <el-checkbox v-for="item in symptomList" :label="item.name" :key="item.value">{{
                                    item.name }}</el-checkbox>
                            </el-checkbox-group>
                        </el-descriptions-item>
                        <el-descriptions-item label="一般状况">
                            <el-descriptions :column="2" size="medium" border :label-style="LS" :contentStyle="CS"
                                style="margin: -10px;">
                                <el-descriptions-item label="体温（℃）">{{ detail.temperature }}</el-descriptions-item>
                                <el-descriptions-item label="脉率（次/分钟）">{{ detail.pulseRate }}</el-descriptions-item>
                                <el-descriptions-item label="呼吸脉率（次/分钟）">{{ detail.breatheRate }}</el-descriptions-item>
                                <el-descriptions-item label="血压">
                                    <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="左侧（mmHg）">{{ detail.sbpLeft + '/' + detail.dbpLeft
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="右侧（mmHg）">{{ detail.sbpRight + '/' +
                                            detail.dbpRight
                                            }}</el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>
                                <el-descriptions-item label="身高（cm）">{{ detail.height }}</el-descriptions-item>
                                <el-descriptions-item label="体重（kg）">{{ detail.weight }}</el-descriptions-item>
                                <el-descriptions-item label="腰围（cm）">{{ detail.waist }}</el-descriptions-item>
                                <el-descriptions-item label="体质指数（BMI Kg/m2）">{{ detail.bmi }}</el-descriptions-item>
                                <el-descriptions-item label="老年人健康状态自我评估*" :span="2">
                                    <el-radio-group style="display: inline" v-model="detail.evalOlderHealthstatus">
                                        <el-radio v-for="(item, index) in healthstatusList" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="老年人生活自理能力自我评估*" :span="2">
                                    <el-radio-group style="display: inline" v-model="detail.evalOlderTakecareself">
                                        <el-radio v-for="(item, index) in takecareselfList" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="老年人认知功能*" :span="2">
                                    <el-radio-group style="display: inline" v-model="detail.evalOlderAcknowledge">
                                        <el-radio v-for="(item, index) in acknowledgeList" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="老年人情感状态*" :span="2">
                                    <el-radio-group style="display: inline" v-model="detail.evalOlderEmotion">
                                        <el-radio v-for="(item, index) in emotionList" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-descriptions-item>

                        <el-descriptions-item label="生活方式">
                            <el-descriptions :column="1" size="medium" style="margin: -10px;" border>
                                <el-descriptions-item label="体育锻炼">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="锻炼频率" :span="2">
                                            <el-radio-group style="display: inline" v-model="detail.sportFreq">
                                                <el-radio v-for="(item, index) in sportFrequencyList" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="每次锻炼时间（分钟）">{{ detail.sportDuration
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="坚持锻炼时间（月）">{{ detail.sportRegularMonth
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="锻炼方式" :span="2">{{ detail.sportDesc
                                            }}</el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="饮食习惯">
                                    <el-checkbox-group style="display: inline" v-model="detail.dietHabit">
                                        <el-checkbox v-for="item in dietHabitList" :label="item.name"
                                            :key="item.value">{{
                                                item.name }}</el-checkbox>
                                    </el-checkbox-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="吸烟情况">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="吸烟状况" :span="2">
                                            <el-radio-group style="display: inline" v-model="detail.smokeStatus">
                                                <el-radio v-for="(item, index) in smokingStatusList" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="日吸烟量（平均/支）" :span="2">{{ detail.smokeNumDay
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="开始吸烟年龄（岁）">{{ detail.smokeInitAge
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="戒烟年龄（岁）">{{ detail.smokeQuitAge
                                            }}</el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="饮酒情况">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="饮酒频率" :span="2">
                                            <el-radio-group style="display: inline" v-model="detail.drinkFreq">
                                                <el-radio v-for="(item, index) in drinkFrequencyList" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="日饮酒量（平均/两）" :span="2">{{ detail.drinkNumDay
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="是否戒酒" :span="2">
                                            <el-radio-group style="display: inline" v-model="detail.drinkIsQuit">
                                                <el-radio v-for="(item, index) in dryOutStatusList" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="开始饮酒年龄">{{ detail.drinkInitAge
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="近一年内是否曾醉酒">{{ detail.drinkIsDrunk
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="饮酒种类" :span="2">
                                            <el-checkbox-group style="display: inline" v-model="detail.drinkCategory">
                                                <el-checkbox v-for="item in drinkCategoryList" :label="item.name"
                                                    :key="item.value">{{
                                                        item.name }}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="职业病危害因素接触史">
                                    <el-descriptions :column="3" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="接触史">
                                            <el-radio-group v-model="detail.vocationExposeFlag">
                                                <el-radio :label="1">无</el-radio>
                                                <el-radio :label="2">有</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="工种">{{ detail.vocationHarmful
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="从业时间（年）">{{ detail.vocationHarmful
                                            }}</el-descriptions-item>

                                        <el-descriptions-item label="毒物种类">
                                            <el-checkbox-group style="display: inline"
                                                v-model="detail.vocationExposeName">
                                                <el-checkbox v-for="item in vocationExposeList" :label="item.name"
                                                    :key="item.value">{{
                                                        item.name }}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-descriptions-item>

                                        <el-descriptions-item label="防护措施" :span="2">
                                            <el-radio-group v-model="detail.vocationExposeProtection">
                                                <el-radio :label="1">无</el-radio>
                                                <el-radio :label="2">有</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                            </el-descriptions>
                        </el-descriptions-item>

                        <el-descriptions-item label="脏器功能">
                            <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                <el-descriptions-item label="口腔">
                                    <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="口唇">
                                            <el-radio-group style="display: inline" v-model="detail.lips">
                                                <el-radio v-for="(item, index) in lipsStatusOptions" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="齿列">
                                            <el-checkbox-group style="display: inline" v-model="detail.dentition">
                                                <el-checkbox v-for="item in dentitionStatusOptions" :label="item.name"
                                                    :key="item.value">{{
                                                        item.name }}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="咽部">
                                            <el-radio-group style="display: inline" v-model="detail.dentalCaries">
                                                <el-radio v-for="(item, index) in dentalCariesStatusOptions"
                                                    :key="index" :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="视力">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="左眼">{{ detail.visionLeftEye
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="右眼">{{ detail.visionRightEye
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="矫正视力：左眼">{{ detail.visionCorrectLeftEye
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="矫正视力：右眼">{{ detail.visionCorrectRightEye
                                            }}</el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="听力">
                                    <el-radio-group style="display: inline" v-model="detail.hearing">
                                        <el-radio v-for="(item, index) in hearingStatusOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="运动功能">
                                    <el-radio-group style="display: inline" v-model="detail.sportFunction">
                                        <el-radio v-for="(item, index) in sportFunctionOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                            </el-descriptions>
                        </el-descriptions-item>

                        <el-descriptions-item label="查体">
                            <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                <el-descriptions-item label="眼底">
                                    <el-radio-group style="display: inline" v-model="detail.fundusFlag">
                                        <el-radio v-for="(item, index) in fundusFlagOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="皮肤">
                                    <el-radio-group style="display: inline" v-model="detail.skin">
                                        <el-radio v-for="(item, index) in skinStatusOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="巩膜">
                                    <el-radio-group style="display: inline" v-model="detail.sclera">
                                        <el-radio v-for="(item, index) in scleraStatusOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="淋巴结">
                                    <el-radio-group style="display: inline" v-model="detail.lymphNodes">
                                        <el-radio v-for="(item, index) in lymphNodesOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="肺">
                                    <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="桶状胸">
                                            <el-radio-group style="display: inline" v-model="detail.barrelChest">
                                                <el-radio v-for="(item, index) in barrelChestOptions" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="呼吸音">
                                            <el-radio-group style="display: inline" v-model="detail.breathSoundFlag">
                                                <el-radio v-for="(item, index) in breathSoundsOptions" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="罗音">
                                            <el-radio-group style="display: inline" v-model="detail.raleFlag">
                                                <el-radio v-for="(item, index) in raleStatusOptions" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="心脏">
                                    <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="心率（次/分钟）">{{ detail.heartRate
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="心律">
                                            <el-radio-group style="display: inline" v-model="detail.heartRhythmType">
                                                <el-radio v-for="(item, index) in heartRhythmOptions" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="杂音">
                                            <el-radio-group style="display: inline" v-model="detail.murmurFlag">
                                                <el-radio v-for="(item, index) in heartMurmurOptions" :key="index"
                                                    :label="item.name"></el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="腹部">
                                    <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="压痛">
                                            <el-radio-group v-model="detail.tendernessFlag">
                                                <el-radio :label="1">无</el-radio>
                                                <el-radio :label="2">有</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="包块">
                                            <el-radio-group v-model="detail.massFlag">
                                                <el-radio :label="1">无</el-radio>
                                                <el-radio :label="2">有</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="肝大">
                                            <el-radio-group v-model="detail.liverEnlargeFlag">
                                                <el-radio :label="1">无</el-radio>
                                                <el-radio :label="2">有</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="脾大">
                                            <el-radio-group v-model="detail.spleenEnlargeFlag">
                                                <el-radio :label="1">无</el-radio>
                                                <el-radio :label="2">有</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="移动性浊音">
                                            <el-radio-group v-model="detail.shiftingDullnessFlag">
                                                <el-radio :label="1">无</el-radio>
                                                <el-radio :label="2">有</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="下肢水肿">
                                    <el-radio-group style="display: inline" v-model="detail.lowerExtremityEdemaCode">
                                        <el-radio v-for="(item, index) in lowerExtremityEdemaOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="足背动脉搏动*">
                                    <el-radio-group style="display: inline" v-model="detail.dorsalisPedisPulse">
                                        <el-radio v-for="(item, index) in dorsalFootPulsesOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="肛门指诊*">
                                    <el-radio-group style="display: inline" v-model="detail.analTypeCode">
                                        <el-radio v-for="(item, index) in analTypeOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="乳腺*">
                                    <el-radio-group style="display: inline" v-model="detail.breastCode">
                                        <el-radio v-for="(item, index) in breastStatusOptions" :key="index"
                                            :label="item.name"></el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="妇科*">
                                    <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="外阴">
                                            <el-radio-group v-model="detail.vulvaAbnormal">
                                                <el-radio :label="1">未见异常</el-radio>
                                                <el-radio :label="2">异常</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="阴道">
                                            <el-radio-group v-model="detail.vaginalAbnormal">
                                                <el-radio :label="1">未见异常</el-radio>
                                                <el-radio :label="2">异常</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="宫颈">
                                            <el-radio-group v-model="detail.cervicalAbnormal">
                                                <el-radio :label="1">未见异常</el-radio>
                                                <el-radio :label="2">异常</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="宫体">
                                            <el-radio-group v-model="detail.uterineBodyAbnormal">
                                                <el-radio :label="1">未见异常</el-radio>
                                                <el-radio :label="2">异常</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="附件">
                                            <el-radio-group v-model="detail.attachmentAbnormal">
                                                <el-radio :label="1">未见异常</el-radio>
                                                <el-radio :label="2">异常</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="其他"></el-descriptions-item>

                            </el-descriptions>
                        </el-descriptions-item>

                        <el-descriptions-item label="辅助检查">
                            <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                <el-descriptions-item label="血常规">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="血红蛋白">{{ detail.bloodHb }}</el-descriptions-item>
                                        <el-descriptions-item label="白细胞">{{ detail.bloodWbc }}</el-descriptions-item>
                                        <el-descriptions-item label="血小板">{{ detail.bloodBpc }}</el-descriptions-item>
                                        <el-descriptions-item label="其他"></el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="尿常规">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="尿蛋白">{{ detail.urinePro }}</el-descriptions-item>
                                        <el-descriptions-item label="尿糖">{{ detail.urineGlu }}</el-descriptions-item>
                                        <el-descriptions-item label="尿酮体">{{ detail.urineKetCode
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="尿潜血">{{ urineBldCode }}</el-descriptions-item>
                                        <el-descriptions-item label="其他"></el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="空腹血糖">{{ detail.fpg }}</el-descriptions-item>

                                <el-descriptions-item label="心电图">
                                    <el-radio-group v-model="detail.ecgAbnormal">
                                        <el-radio :label="1">正常</el-radio>
                                        <el-radio :label="2">异常</el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="尿微量白蛋白*">{{ detail.urineLeu }}</el-descriptions-item>
                                <el-descriptions-item label="大便潜血*">{{ detail.fob }}</el-descriptions-item>
                                <el-descriptions-item label="糖化血红蛋白*">{{ detail.hba1c }}</el-descriptions-item>
                                <el-descriptions-item label="乙型肝炎表面抗原*">
                                    <el-radio-group v-model="detail.hbsag">
                                        <el-radio :label="1">阴性</el-radio>
                                        <el-radio :label="2">阳性</el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="肝功能*">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="血清谷丙转氨酶">{{ detail.bloodAlt
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="血清谷草转氨酶">{{ detail.bloodAst
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="白蛋白">{{ detail.bloodAlb }}</el-descriptions-item>
                                        <el-descriptions-item label="总胆红素">{{ detail.bloodTbil }}</el-descriptions-item>
                                        <el-descriptions-item label="结合胆红素">{{ detail.bloodDbil
                                            }}</el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="肾功能*">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="血清肌酐">{{ detail.bloodScr }}</el-descriptions-item>
                                        <el-descriptions-item label="血尿素">{{ detail.bloodBun }}</el-descriptions-item>
                                        <el-descriptions-item label="血钾浓度">{{ detail.bloodK }}</el-descriptions-item>
                                        <el-descriptions-item label="血钠浓度">{{ detail.bloodNa }}</el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="血脂*">
                                    <el-descriptions :column="2" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="总胆固醇">{{ detail.tc }}</el-descriptions-item>
                                        <el-descriptions-item label="甘油三酯">{{ detail.tg }}</el-descriptions-item>
                                        <el-descriptions-item label="血清低密度脂蛋白胆固醇">{{ detail.ldlc
                                            }}</el-descriptions-item>
                                        <el-descriptions-item label="血清高密度脂蛋白胆固醇">{{ detail.hdlc
                                            }}</el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="胸部X线片*">
                                    <el-radio-group v-model="detail.chestXAbnormal">
                                        <el-radio :label="1">正常</el-radio>
                                        <el-radio :label="2">异常</el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>

                                <el-descriptions-item label="B超*">
                                    <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                        <el-descriptions-item label="腹部B超">
                                            <el-radio-group v-model="detail.bultrasoundAbnormal">
                                                <el-radio :label="1">正常</el-radio>
                                                <el-radio :label="2">异常</el-radio>
                                            </el-radio-group>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="其他"></el-descriptions-item>
                                    </el-descriptions>
                                </el-descriptions-item>

                                <el-descriptions-item label="宫颈涂片*">
                                    <el-radio-group v-model="detail.cervicalAbnormal">
                                        <el-radio :label="1">正常</el-radio>
                                        <el-radio :label="2">异常</el-radio>
                                    </el-radio-group>
                                </el-descriptions-item>
                                <el-descriptions-item label="其他*">{{ detail.otherAuxiliaryExam }}</el-descriptions-item>

                            </el-descriptions>
                        </el-descriptions-item>

                        <el-descriptions-item label="现存主要健康问题">
                            <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                <el-descriptions-item label="脑血管疾病"></el-descriptions-item>
                                <el-descriptions-item label="肾脏疾病"></el-descriptions-item>
                                <el-descriptions-item label="心脏疾病"></el-descriptions-item>
                                <el-descriptions-item label="血管疾病"></el-descriptions-item>
                                <el-descriptions-item label="眼部疾病"></el-descriptions-item>
                                <el-descriptions-item label="神经系统疾病"></el-descriptions-item>
                                <el-descriptions-item label="其他系统疾病"></el-descriptions-item>
                            </el-descriptions>
                        </el-descriptions-item>

                        <el-descriptions-item label="住院治疗情况">
                            <el-descriptions :column="1" size="medium" border style="margin: -10px;">
                                <el-descriptions-item label="住院史">
                                    <el-table :data="tableData" height="200" border style="width: 100%;">
                                        <el-table-column prop="date" label="入/出院日期" width="180">
                                        </el-table-column>
                                        <el-table-column prop="reason" label="原因" width="180">
                                        </el-table-column>
                                        <el-table-column prop="orgName" label="医疗机构名称">
                                        </el-table-column>
                                        <el-table-column prop="code" label="病案号">
                                        </el-table-column>
                                    </el-table>
                                </el-descriptions-item>
                                <el-descriptions-item label="家庭病床史"></el-descriptions-item>
                            </el-descriptions>
                        </el-descriptions-item>

                        <el-descriptions-item label="主要用药情况">
                        </el-descriptions-item>

                        <el-descriptions-item label="非免疫规划预防接种史">
                        </el-descriptions-item>

                        <el-descriptions-item label="健康评价">
                        </el-descriptions-item>

                        <el-descriptions-item label="健康指导">
                        </el-descriptions-item>

                    </el-descriptions>
                </div>
            </el-container>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="medium" plain @click="showDialog = false">关闭</el-button>
            </span>

        </el-dialog>
    </div>
</template>
<script>

export default {
    components: {},
    data() {
        return {
            activeName: "first",
            treeData: [],
            showDialog: false,
            title: "健康体检表",
            CS: {
                'text-align': 'center',  //文本居中
                'min-width': '200px',  //最小宽度
                'word-break': 'break-all'  //过长时自动换行

            },
            LS: {
                'min-width': '200px',
                'word-break': 'keep-all'
            },
            symptomList: [
                {
                    value: "1",
                    name: "无症状"
                },
                {
                    value: "2",
                    name: "头痛"
                },
                {
                    value: "3",
                    name: "头晕"
                },
                {
                    value: "4",
                    name: "心悸"
                },
                {
                    value: "5",
                    name: "胸闷"
                },
                {
                    value: "6",
                    name: "胸痛"
                },
                {
                    value: "7",
                    name: "慢性咳嗽"
                },
                {
                    value: "8",
                    name: "咳痰"
                },
                {
                    value: "9",
                    name: "呼吸困难"
                },
                {
                    value: "10",
                    name: "多饮"
                },
                {
                    value: "11",
                    name: "多尿"
                },
                {
                    value: "12",
                    name: "体重下降"
                },
                {
                    value: "13",
                    name: "乏力"
                },
                {
                    value: "14",
                    name: "关节肿痛"
                },
                {
                    value: "15",
                    name: "视力模糊"
                },
                {
                    value: "16",
                    name: "手脚麻木"
                },
                {
                    value: "17",
                    name: "尿急"
                },
                {
                    value: "18",
                    name: "尿痛"
                },
                {
                    value: "19",
                    name: "便秘"
                },
                {
                    value: "20",
                    name: "腹泻"
                },
                {
                    value: "21",
                    name: "恶心呕吐"
                },
                {
                    value: "22",
                    name: "眼花"
                },
                {
                    value: "23",
                    name: "耳鸣"
                },
                {
                    value: "24",
                    name: "乳房胀痛"
                },
                {
                    value: "25",
                    name: "其他"
                }],
            healthstatusList: [
                {
                    value: "1",
                    name: "满意"
                },
                {
                    value: "2",
                    name: "基本满意"
                },
                {
                    value: "3",
                    name: "说不清楚"
                },
                {
                    value: "4",
                    name: "不太满意"
                },
                {
                    value: "5",
                    name: "不满意"
                }
            ],
            takecareselfList: [
                {
                    value: "1",
                    name: "可自理（0～3 分）"
                },
                {
                    value: "2",
                    name: "轻度依赖（4～8 分）"
                },
                {
                    value: "3",
                    name: "中度依赖（9～18 分)"
                },
                {
                    value: "4",
                    name: "不能自理（≥19 分）"
                }
            ],
            acknowledgeList: [{
                value: "1",
                name: "粗筛阴性"
            },
            {
                value: "2",
                name: "粗筛阳性"
            }],
            emotionList: [{
                value: "1",
                name: "粗筛阴性"
            },
            {
                value: "2",
                name: "粗筛阳性"
            }],
            sportFrequencyList: [
                {
                    value: "1",
                    name: "每天"
                },
                {
                    value: "2",
                    name: "每周一次以上"
                },
                {
                    value: "3",
                    name: "偶尔"
                },
                {
                    value: "4",
                    name: "不锻炼"
                }],
            dietHabitList: [
                {
                    value: "1",
                    name: "荤素均衡"
                },
                {
                    value: "2",
                    name: "荤食为主"
                },
                {
                    value: "3",
                    name: "素食为主"
                },
                {
                    value: "4",
                    name: "嗜盐"
                },
                {
                    value: "5",
                    name: "嗜油"
                },
                {
                    value: "6",
                    name: "嗜糖"
                }],
            smokingStatusList: [
                {
                    value: "1",
                    name: "从不吸烟"
                },
                {
                    value: "2",
                    name: "已戒烟"
                },
                {
                    value: "3",
                    name: "吸烟"
                }],
            drinkFrequencyList: [
                {
                    value: "1",
                    name: "从不"
                },
                {
                    value: "2",
                    name: "偶尔"
                },
                {
                    value: "3",
                    name: "经常"
                },
                {
                    value: "3",
                    name: "每天"
                }],
            dryOutStatusList: [
                {
                    value: "1",
                    name: "未戒酒"
                },
                {
                    value: "2",
                    name: "已戒酒"
                }],
            drinkCategoryList: [
                { value: "1", name: "白酒" },
                { value: "2", name: "啤酒" },
                { value: "3", name: "红酒" },
                { value: "4", name: "黄酒" },
                { value: "5", name: "其他" }
            ],
            vocationExposeList: [
                { value: "1", name: "粉尘" },
                { value: "2", name: "放射物质" },
                { value: "3", name: "物理因素" },
                { value: "4", name: "化学物质" },
                { value: "5", name: "其他" }
            ],
            lipsStatusOptions: [
                {
                    value: "1",
                    name: "红润",
                },
                {
                    value: "2",
                    name: "苍白",
                },
                {
                    value: "3",
                    name: "发绀",
                },
                {
                    value: "4",
                    name: "皲裂",
                },
                {
                    value: "5",
                    name: "疱疹",
                },
            ],
            dentitionStatusOptions: [
                {
                    value: "1",
                    name: "正常",
                },
                {
                    value: "2",
                    name: "缺齿",
                },
                {
                    value: "3",
                    name: "龋齿",
                },
                {
                    value: "4",
                    name: "义齿（假牙）",
                },
            ],
            dentalCariesStatusOptions: [
                {
                    value: "1",
                    name: "无充血",
                },
                {
                    value: "2",
                    name: "充血",
                },
                {
                    value: "3",
                    name: "淋巴滤泡增生",
                },
            ],
            hearingStatusOptions: [
                {
                    value: "1",
                    name: "听见",
                },
                {
                    value: "2",
                    name: "听不清或无法听见",
                }
            ],
            sportFunctionOptions: [
                {
                    value: "1",
                    name: "可顺利完成",
                },
                {
                    value: "2",
                    name: "无法独立完成任何一个动作",
                }
            ],
            fundusFlagOptions: [
                {
                    value: "1",
                    name: "正常",
                },
                {
                    value: "2",
                    name: "异常",
                }
            ],
            skinStatusOptions: [
                {
                    value: "1",
                    name: "正常",
                },
                {
                    value: "2",
                    name: "潮红",
                },
                {
                    value: "3",
                    name: "苍白",
                },
                {
                    value: "4",
                    name: "发绀",
                },
                {
                    value: "5",
                    name: "黄染",
                },
                {
                    value: "6",
                    name: "色素沉淀",
                },
                {
                    value: "7",
                    name: "其他",
                },
            ],
            scleraStatusOptions: [
                {
                    value: "1",
                    name: "正常",
                },
                {
                    value: "2",
                    name: "黄染",
                },
                {
                    value: "3",
                    name: "充血",
                },
                {
                    value: "4",
                    name: "其他",
                },
            ],
            lymphNodesOptions: [
                {
                    value: "1",
                    name: "未触及",
                },
                {
                    value: "2",
                    name: "锁骨上",
                },
                {
                    value: "3",
                    name: "腋窝",
                },
                {
                    value: "4",
                    name: "其他",
                },
            ],
            barrelChestOptions: [
                {
                    value: "1",
                    name: "是",
                },
                {
                    value: "2",
                    name: "否",
                },
            ],
            breathSoundsOptions: [
                {
                    value: "1",
                    name: "正常",
                },
                {
                    value: "2",
                    name: "异常",
                },
            ],
            raleStatusOptions: [
                {
                    value: "1",
                    name: "无",
                },
                {
                    value: "2",
                    name: "干罗音",
                },
                {
                    value: "3",
                    name: "湿罗音",
                },
                {
                    value: "4",
                    name: "其他",
                },
            ],
            heartRhythmOptions: [
                {
                    value: "1",
                    name: "齐",
                },
                {
                    value: "2",
                    name: "不齐",
                },
                {
                    value: "3",
                    name: "绝对不齐",
                },
            ],
            heartMurmurOptions: [
                {
                    value: "1",
                    name: "无",
                },
                {
                    value: "2",
                    name: "有",
                },
            ],
            lowerExtremityEdemaOptions: [
                {
                    value: "1",
                    name: "无",
                },
                {
                    value: "2",
                    name: "单侧",
                },
                {
                    value: "3",
                    name: "双侧不对称",
                },
                {
                    value: "4",
                    name: "双侧对称",
                },
            ],
            dorsalFootPulsesOptions: [
                {
                    value: "1",
                    name: "未触及",
                },
                {
                    value: "2",
                    name: "触及双侧",
                },
                {
                    value: "3",
                    name: "触及左侧微弱或消失",
                },
                {
                    value: "4",
                    name: "触及右侧微弱或消失",
                },
            ],
            breastStatusOptions: [
                {
                    value: "1",
                    name: "未见异常",
                },
                {
                    value: "2",
                    name: "乳房切除",
                },
                {
                    value: "3",
                    name: "异常泌乳",
                },
                {
                    value: "4",
                    name: "乳腺包块",
                },
                {
                    value: "5",
                    name: "其他",
                },
            ],
            analTypeOptions: [
                {
                    value: "1",
                    name: "未及异常",
                },
                {
                    value: "2",
                    name: "触痛",
                },
                {
                    value: "3",
                    name: "包块",
                },
                {
                    value: "4",
                    name: "前列腺异常",
                },
                {
                    value: "5",
                    name: "其他",
                },
            ],
            detail: {
                id: 2106113,
                healthNo: "370284180151036903",
                name: "高礼欣",
                physicalExamNum: "2106113",
                responseDoctorName: "殷秀芳",
                physicalExamTime: "2017-08-16 00:00:00",
                symptomCode: "0",
                symptomName: ["无症状"],
                temperature: "36.3",
                pulseRate: "74",
                breatheRate: "18",
                sbpLeft: "140",
                dbpLeft: "80",
                sbpRight: "130",
                dbpRight: "80",
                height: "158",
                weight: "75",
                waist: "95",
                bmi: "30.04",
                evalOlderHealthstatus: '1',
                evalOlderTakecareself: '1',
                evalOlderAcknowledge: '1',
                evalOlderAcknowledgeRank: null,
                evalOlderEmotion: '1',
                evalOlderDepression: null,
                sportFreq: null,
                sportDuration: null,
                sportRegularMonth: null,
                sportDesc: null,
                dietHabit: [],
                smokeStatus: null,
                smokeNumDay: null,
                smokeInitAge: null,
                smokeQuitAge: null,
                drinkFreq: null,
                drinkNumDay: null,
                drinkIsQuit: null,
                drinkQuitAge: null,
                drinkInitAge: null,
                drinkIsDrunk: null,
                drinkCategory: [],
                vocationExposeFlag: null,
                vocationHarmful: null,
                vocationHarmfulDuration: null,
                vocationExposeType: [],
                vocationExposeName: [],
                vocationExposeProtection: null,
                lips: "1",
                dentition: [],
                denture: null,
                dentalCaries: "1",
                visionLeftEye: "4.8",
                visionRightEye: "4.8",
                visionCorrectLeftEye: null,
                visionCorrectRightEye: null,
                hearing: "1",
                sportFunction: "1",
                fundusFlag: null,
                fundus: null,
                skin: "1",
                sclera: "1",
                lymphNodes: "1",
                barrelChest: 1,
                breathSoundFlag: 1,
                breathSound: "1",
                raleFlag: null,
                rale: null,
                heartRate: "74",
                heartRhythmType: "1",
                murmurFlag: 1,
                murmur: "无",
                tendernessFlag: 1,
                tenderness: null,
                massFlag: 1,
                mass: null,
                liverEnlargeFlag: 1,
                liverEnlarge: null,
                spleenEnlargeFlag: 1,
                spleenEnlarge: null,
                shiftingDullnessFlag: 1,
                shiftingDullness: null,
                lowerExtremityEdemaCode: "1",
                dorsalisPedisPulse: "2",
                analTypeCode: null,
                breastCode: null,
                vulvaAbnormal: null,
                vulvaDesc: null,
                vaginalAbnormal: null,
                vaginalDesc: null,
                cervicalAbnormal: null,
                cervicalDesc: null,
                uterineBodyAbnormal: null,
                uterineBodyDesc: null,
                attachmentAbnormal: null,
                attachmentDesc: null,
                otherPhysicalExamResult: null,
                bloodHb: null,
                bloodWbc: null,
                bloodBpc: null,
                urineProCode: null,
                urinePro: null,
                urineGluCode: null,
                urineGlu: null,
                urineKetCode: null,
                urineBldCode: null,
                urineSg: null,
                urinePh: null,
                urineLeu: null,
                fpg: null,
                pbg: null,
                ecgAbnormal: null,
                ecgDesc: null,
                fob: null,
                hba1c: null,
                hbsag: null,
                hbeag: null,
                hbsab: null,
                hbeab: null,
                hbcab: null,
                bloodAlt: null,
                bloodAst: null,
                bloodAlb: null,
                bloodTbil: null,
                bloodDbil: null,
                bloodScr: null,
                bloodBun: null,
                bloodK: null,
                bloodNa: null,
                tc: null,
                tg: null,
                ldlc: null,
                hdlc: null,
                cea: null,
                chestXAbnormal: null,
                chestXDesc: null,
                cervicalSmearAbnormal: null,
                cervicalSmearDesc: null,
                otherAuxiliaryExam: null,
                tcmConstitutionTypeCode: null,
                tcmConstitutionTypeJudgmentCode: null,
                majorHealthCode: null,
                inDate: null,
                inReason: null,
                outDate: null,
                orgHospitalized: null,
                caseNumHospitalized: null,
                orgHomeHospitalBed: null,
                caseNumHomeHospitalBed: null,
                dateHomeHospitalBed: null,
                reasonHomeHospitalBed: null,
                cancelHomeHospitalBed: null,
                tcmType: null,
                drugName: null,
                drugDosageFreq: null,
                drugDosageUnit: null,
                drugPerdose: null,
                drugDosageTotal: null,
                drugRouteCode: null,
                drugAdherence: null,
                vaccineCode: null,
                vaccineBatchNum: null,
                vaccineDate: null,
                vaccineOrg: null,
                healthEvaluationAbnormal: "高血压",
                healthEvaluationDesc: "2",
                healthGuidanceCode: "1",
                hazardFactorControlSuggestionCode: null,
                weightTarget: "59",
                adviceVaccineCode: null,
                result: null,
                bultrasoundAbnormal: null,
                bultrasoundDesc: null
            },
        }
    },
    created() {
    },
    methods: {
        async init(value) {
            this.initData();
            this.showDialog = true;
        },
        initData() {

        },
        setDialogClosed() {
            this.initData();
            this.showDialog = false;
        },
        // 计算年龄
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep {
    .el-dialog {
        margin-top: 5vh !important;
    }

    .el-descriptions-item__label.is-bordered-label {
        width: 120px !important;
    }

    .el-input {
        width: 200px;
    }
}
</style>